import { render, staticRenderFns } from "./GenericFileEdit.vue?vue&type=template&id=9ccc09e6&scoped=true&"
import script from "./GenericFileEdit.vue?vue&type=script&lang=js&"
export * from "./GenericFileEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccc09e6",
  null
  
)

export default component.exports